
import Vue from "vue";

export default Vue.extend({
  name: "ConfirmPrivacyDialog",

  data: () => ({
    model: false as boolean,
    logo: require("@/assets/images/usmf-logo.png"),
    checkboxes: [
      {
        type: 1,
        value: false,
        text: "Îmi asum, pe proprie răspundere, corectitudinea, completitudinea și conformitatea informațiilor pe care le voi declara on-line pe  platformă",
      },
      {
        type: 2,
        value: false,
        text: "Sunt de acord cu prelucrarea datelor cu caracter personal",
      },
      {
        type: 3,
        value: false,
        text: "Sunt de acord cu prevederile Regulamentului de admitere",
      },
    ] as Array<any>,
  }),

  computed: {
    disabled() {
      return this.checkboxes.some((item: any) => !item.value);
    },
    user() {
      return this.$store.getters["authentication/credentials"]?.user;
    },
  },

  beforeMount() {
    this.checkPrivacyPolicy();
  },

  methods: {
    toggle() {
      this.model = !this.model;
    },
    checkPrivacyPolicy() {
      if (!this.user || this.user.role !== "guest") {
        return;
      }

      const privacy = JSON.parse(
        localStorage.getItem(`privacyConfirmation_${this.user.uuid}`) || "false"
      );
      this.model = !privacy;
    },
    confirmPrivacy() {
      localStorage.setItem(`privacyConfirmation_${this.user.uuid}`, JSON.stringify(true));
      this.model = false;
    },
  },
});
